import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  position: relative;
  z-index: 1;
`;

export const SelectedDateWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  cursor: pointer;
`;

export const SelectedDateText = styled(typography.BodyTextOneRegularTypography)`
  flex-grow: 1;
  margin: 0;
`;

export const SelectedDateIcon = styled.span`
  &: before {
    content: '\\e913';
    font-family: 'Icomoon';
    font-size: 12px;
    color: ${({ theme }) => theme.colors.black};
  }
`;

export const SelectorWrapper = styled.div`
  position: absolute;
  top: 30px;

  & .rdrCalendarWrapper {
    background-color: ${({ theme }) => theme.colors.grey100};
    border: 1px solid ${({ theme }) => theme.colors.grey002};
  }
`;
